<span mat-dialog-title>{{ 'ACCOUNT.DELETE_ADDRESS.TITLE' | translate }}</span>
<div mat-dialog-content>
  <p>{{ 'ACCOUNT.DELETE_ADDRESS.INFO' | translate }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close="false" class="dark-plain-button">{{ 'GENERAL.CANCEL' | translate }}</button>
  <button mat-button mat-dialog-close="true" color="warn">
    {{ 'ACCOUNT.DELETE_ADDRESS.DELETE_ADDRESS' | translate }}
  </button>
</div>
